module.exports = __webpack_public_path__ + "static/assets/d1acdd70243675ecbfcece37be96ac35.svg";